import React from 'react';
import PropTypes from 'prop-types';
import ListView from 'components/common/ListView';

@autobind
/**
 *
 * @class ReportsList
 * @extends PureComponent
 */
export default class NewReportsList extends React.PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    activeItem: PropTypes.number,
    onSearch: PropTypes.func,
    onClick: PropTypes.func,
    reference: PropTypes.func,
    menu: PropTypes.func,
    extra: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
    loading: PropTypes.bool,
    pagination: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
    ]),
  };

  static defaultProps = {
    items: [],
    loading: true,
    pagination: {},
    reference: (input) => {},
  };



    /**
   *
   * @return {XML}
   */
  render() {
    const {items, activeItem, onSearch, onClick, menu,
      extra, loading, pagination, reference, ...rest} = this.props;

    return (
      <ListView
        ref={reference}
        {...rest}
        title={app.translate('routes.home.attendance.reports.Reports new')}
        items={items}
        primaryText={(item)=> (`${item.label}`)}
        secondaryText={'description'}
        style={{height: '100%'}}
        activeItem={activeItem}
        onClick={onClick}
        menu={menu}
        extra={extra}
        loading={loading}
        pagination={pagination}
        icon={true}
      />
    );
  }
}
